import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Accordion, AccordionTab } from 'primereact/accordion';
import './sceneEvent.css';
import { useParams } from 'react-router-dom';
import { useGetSceneListByLocationMutation } from '../../../../../services/scenes/sceneService';

interface SceneEventProps {
  scene?: any;
  emitSelectedScene: (selectedScene: any) => void;
}

const img = require('../../../../../assets/images/eventsType/ScenesActive.png');

export const SceneEvent = ({ emitSelectedScene, scene }: SceneEventProps) => {
  const { locationId } = useParams();

  const [getScenes, { isSuccess, data }] = useGetSceneListByLocationMutation();

  useEffect(() => {
    if (locationId) {
      getScenes(+locationId);
    }
  }, []);

  return (
    <div className="row">
      <div className="col-12">
        <div className="container-scenes">
          <img src={img} alt="scenes" height="60" />
          {data && (
            <Dropdown
              value={scene}
              options={data}
              onChange={(e) => emitSelectedScene(e.value)}
              optionLabel="name"
              placeholder="Select a Scene"
              className="w-100 d-flex align-items-center"
            />
          )}
        </div>
      </div>
      {data && scene && (
        <Accordion>
          <AccordionTab header="View Summary">
            {scene.actions.map((item: any, index: any) => (
              <p key={index} className="summary-scene">
                - {item.summary} {item.targets}
              </p>
            ))}
          </AccordionTab>
        </Accordion>
      )}
    </div>
  );
};
